// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"aX-z","sponsoredTooltipWrapper":"bX-z","sponsoredTooltip":"cX-z","newCard":"dX-z"};